import imageCompression from "browser-image-compression";

export const compressMedia = async (file, type, onProgress) => {
  try {
    if (type === "image") {
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
        onProgress: (p) => {
          if (onProgress) onProgress(p); // send back to parent
        },
      };
      let compressed = await imageCompression(file, options);
      let quality = 0.9;
      while (compressed.size > 500 * 1024 && quality > 0.3) {
        compressed = await imageCompression(
          new File([compressed], file.name, { type: file.type }),
          { ...options, initialQuality: quality }
        );
        quality -= 0.1;
      }
      const finalFile = new File([compressed], file.name, { type: file.type });
      return finalFile;
    }
    return file;
  } catch (e) {
    console.error("Media Compression failed:", e);
    return file;
  }
};